module.exports = __webpack_public_path__ + "static/Gallery-8-e73bd27e98533fa207929c57c7291814.jpg";